export const timeFormat = (seconds, minutes, hours, day, months, years) => {
  if (seconds) {
    const date = new Date()
    date.setSeconds(date.getSeconds() + seconds)
    return date
  }
  if (minutes) {
    const date = new Date()
    date.setMinutes(date.getMinutes() + minutes)
    return date
  }
  if (hours) {
    const date = new Date()
    date.setHours(date.getHours() + hours)
    return date
  }
  if (day) {
    const date = new Date()
    date.setDate(day)
    return date
  }
  if (months) {
    const date = new Date()
    date.setMonth(date.getMonth() + months)
    return date
  }
  if (years) {
    const date = new Date()
    date.setYear(date.getYear() + years)
    return date.toGMTString()
  }
}

// Usage:
// timeFormat(0, 0, 8, 0, 0, 0)

export default timeFormat
